import React from 'react'

import ConfirmationPopoverContent, {
  type ConfirmationPopoverContentProps,
} from '../../ConfirmationPopover/ConfirmationPopoverContent'

type MenuConfirmationProps = {
  confirmation: Omit<ConfirmationPopoverContentProps, 'cancelCallout'>
  callout: (isConfirm: boolean) => void
  /** Optional prop to add a test id to the MenuConfirmation for QA testing */
  qaTestId?: string
}

const MenuConfirmation = ({
  confirmation,
  callout,
  qaTestId,
}: MenuConfirmationProps): React.JSX.Element => {
  const confirm = () => {
    confirmation?.confirmCallout()
    callout(true)
  }

  const cancel = () => {
    callout(false)
  }

  return (
    <ConfirmationPopoverContent
      {...confirmation}
      confirmCallout={confirm}
      cancelCallout={cancel}
      qaTestId={`${qaTestId}-confirmation-popover`}
    />
  )
}

export default MenuConfirmation
